import { render, staticRenderFns } from "./PlantListHeader.vue?vue&type=template&id=055887a6&scoped=true&"
import script from "./PlantListHeader.vue?vue&type=script&lang=ts&"
export * from "./PlantListHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PlantListHeader.vue?vue&type=style&index=0&id=055887a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055887a6",
  null
  
)

export default component.exports